import { render, staticRenderFns } from "./ShippingBulk3p.vue?vue&type=template&id=2c5c2aee"
import script from "./ShippingBulk3p.vue?vue&type=script&lang=js"
export * from "./ShippingBulk3p.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports